import { render, staticRenderFns } from "./ListStudent.vue?vue&type=template&id=28d34dee&scoped=true"
import script from "./ListStudent.vue?vue&type=script&lang=js"
export * from "./ListStudent.vue?vue&type=script&lang=js"
import style0 from "./ListStudent.vue?vue&type=style&index=0&id=28d34dee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d34dee",
  null
  
)

export default component.exports